import * as React from 'react';
import { useEffect, useState, useCallback } from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';

import { cn, JobSimilarPositionsType, useModal } from '@restworld/utils-common';
import { Button, Heading, Modal, ModalContent } from '@restworld/ui-ds-base';
import { LinkBase } from '@restworld/ui-components';

export function JobExpireInformation({
  similarJobPositions,
  showRestaurantDetails,
  restaurantSlug,
}: JobExpireInformationProps) {
  const [showSimilarPositions, similarPositionsToggler] = useState(false);
  const { show, open, close } = useModal();

  const similarPositionToggler = useCallback(() => similarPositionsToggler((prev) => !prev), []);

  useEffect(() => {
    open();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const similarJobsEl = document.getElementById('similar-jobs-el');
    if (similarJobsEl && showSimilarPositions) {
      close();
      similarJobsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [close, showSimilarPositions]);
  return (
    <Modal open={show} onOpenChange={(open) => !open && close()}>
      <ModalContent hideHeader className="w-full md:max-w-[26rem] md:min-w-[22rem]">
        <Wrapper>
          <ExclamationCircleIcon className="w-13 h-13 text-red-600 mb-4 " />
          <Heading size={3} weight="semibold" align="center" className="leading-7 mb-2">
            {modalTitle}
          </Heading>
          <Heading size={6} color="muted" className="mb-7">
            {modalBody}
          </Heading>
          <div className="flex flex-col items-center w-full gap-4 ">
            {similarJobPositions.length > 0 ? (
              <Button fullwidth variant="primary" onClick={similarPositionToggler}>
                Mostra posizioni simili
              </Button>
            ) : null}
            <LinkBase
              link={showRestaurantDetails ? `/locale/${restaurantSlug}` : '/cerco-lavoro'}
              newTab={false}
              className={'w-full'}
            >
              {' '}
              <Button fullwidth variant="secondary-neutral">
                {showRestaurantDetails ? 'Esplora pagina del locale' : 'Esplora tutte le posizioni'}
              </Button>
            </LinkBase>
          </div>
        </Wrapper>
      </ModalContent>
    </Modal>
  );
}
export default JobExpireInformation;
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col items-center', className)} {...props} />
);
export interface JobExpireInformationProps {
  similarJobPositions: JobSimilarPositionsType[];
  restaurantSlug?: string;
  showRestaurantDetails?: boolean;
}

const modalTitle = `La candidatura non è più attiva per questa posizione`;
const modalBody = `Questa posizione è stata già occupata o chiusa. Trova nuove possibilità o usa l’autocandidatura sulla pagina del locale per altre opportunità!`;
